module.exports = __webpack_public_path__ + "img/Right.04d5700d.svg";